export default "__VITE_ASSET__na09sRQJ__"